import VueRouter, { RouteConfig } from 'vue-router';
import { withPrefix } from '.';

export default (router: VueRouter): RouteConfig[] => {
    return withPrefix('/deployment', [
        {
            path: '',
            name: 'deployment',
            component: () => import('@/views/deployment/Deployment.vue'),
            redirect: { name: 'version' },
            children: [
                {
                    path: 'version',
                    name: 'version',
                    component: () => import('@/views/deployment/Version.vue'),
                },
                {
                    path: 'contact-info',
                    name: 'contact-info-edit',
                    component: () => import('@/views/deployment/ContactInfoEdit.vue')
                },
            ]
        },
    ]);
};
